import React, {useEffect, useState} from 'react';
import SwiperCore, {A11y, Autoplay, EffectFade, Pagination} from 'swiper';

import {Swiper, SwiperSlide} from 'swiper/react';
import 'swiper/swiper.scss';
import 'swiper/components/pagination/pagination.scss';
import 'swiper/components/effect-fade/effect-fade.scss';

import './_bannerBlock.scss';
import {Link} from 'react-router-dom';
import ScrollToButton from '../../common/scrollToButton/scrollToButton';
import {Link as ScrollLink} from 'react-scroll';

// install Swiper components
SwiperCore.use([Pagination, A11y, EffectFade, Autoplay]);

export default function BannerBlock({
                                        data,
                                        fullHeight,
                                        scrollTo,
                                        pageName,
                                        pressPage,
                                        color,
                                        position,
                                    }) {
    const [loop, setLoop] = useState(false);
    const [offset, setOffset] = useState(null);

    useEffect(() => {
        const headLineOffset =
            document &&
            document.getElementById('headLine') &&
            -document.getElementById('headLine').offsetHeight;
        setOffset(headLineOffset);

        setTimeout(() => {
            setLoop(true);
        }, 1000);
    }, []);

    return (
        <section
            className={`${fullHeight ? 'fullHeight' : ''} ${
                pageName || ''
            } banner-section mb-0`}
        >
            <Link to='/' className='banner-logo'>
                <img src='/media/images/InClassica_White.svg' alt='banner-logo'/>
            </Link>
            {data && data.length > 1
                ? loop && (
                <Swiper
                    // loop={true}
                    speed={1000}
                    effect='fade'
                    autoplay={{disableOnInteraction: false, delay: 10000}}
                    spaceBetween={50}
                    slidesPerView={1}
                    pagination={{clickable: true}}
                    initialSlide={0}
                    // onInit={(swiper)=>slideTo(swiper)}
                    // onSwiper={(swiper)=>slideTo(swiper)}
                    onSlideChange={() => console.log('slide change')}
                >
                    {data &&
                    data.map((el, i) => {
                        return el.type.includes('image') ? (
                            <SwiperSlide key={i}>
                                <div
                                    style={{backgroundImage: `url(${el.url})`}}
                                    className='banner-img d-none d-md-block'
                                >
                                    <div className='banner-container'>
                                        <div
                                            dangerouslySetInnerHTML={{__html: el.text}}
                                            className={`banner-context ${color} ${position}`}
                                        />
                                    </div>
                                </div>
                                <div
                                    style={{
                                        backgroundImage: `url(${
                                            el.mobile_url !== undefined &&
                                            el.mobile_url !== null
                                                ? el.mobile_url
                                                : el.url
                                        })`,
                                    }}
                                    className='banner-img d-md-none d-block'
                                >
                                    <div className='banner-container'>
                                        <div
                                            dangerouslySetInnerHTML={{__html: el.text}}
                                            className={`banner-context ${color} ${position}`}
                                        />
                                    </div>
                                </div>
                            </SwiperSlide>
                        ) : (
                            <SwiperSlide key={i}>
                                <div className='banner-img'>
                                    <video
                                        src={el.url}
                                        autoPlay
                                        muted
                                        loop
                                        webkitplaysinline='true'
                                        playsInline
                                        className='banner-video'
                                    />
                                    <div className='banner-container'>
                                        <div
                                            dangerouslySetInnerHTML={{__html: el.text}}
                                            className={`banner-context ${color} ${position}`}
                                        />
                                    </div>
                                </div>
                            </SwiperSlide>
                        );
                    })}
                </Swiper>
            )
                : data && Array.isArray(data)
                    ? data.map((el) => (
                        <>
                            {el.type.includes('image')
                                ?
                                <div
                                    style={{backgroundImage: `url(${el.url})`}}
                                    className={`banner-img d-none d-md-block ${
                                        fullHeight ? 'fullHeight' : ''
                                    }`}
                                >
                                    <div className='banner-container'>
                                        <div
                                            dangerouslySetInnerHTML={{__html: el.text}}
                                            className={`banner-context ${color} ${position}`}
                                        />
                                        {scrollTo && (
                                            <ScrollToButton
                                                elementId={scrollTo.elementId}
                                                offset={offset}
                                                duration={1000}
                                            />
                                        )}
                                        {pressPage && (
                                            <ScrollLink
                                                smooth
                                                duration={1000}
                                                to='pressListAccreditation'
                                                offset={-100}
                                                className='scrollPressButton'
                                            >
                                                GET ACCREDITED
                                            </ScrollLink>
                                        )}
                                    </div>
                                </div>
                                :
                                <div className={`banner-img d-none d-md-block ${
                                    fullHeight ? 'fullHeight' : ''
                                }`}>
                                    <video
                                        src={el.url}
                                        autoPlay
                                        muted
                                        loop
                                        webkitplaysinline='true'
                                        playsInline
                                        className='banner-video'
                                    />
                                    <div className='banner-container'>
                                        <div
                                            dangerouslySetInnerHTML={{__html: el.text}}
                                            className={`banner-context ${color} ${position}`}
                                        />
                                    </div>
                                </div>
                            }
                            <div
                                style={{
                                    backgroundImage: `url(${
                                        el.mobile_url !== undefined && el.mobile_url !== null
                                            ? el.mobile_url
                                            : el.url
                                    })`,
                                }}
                                className={`banner-img d-md-none d-block ${
                                    fullHeight ? 'fullHeight' : ''
                                }`}
                            >
                                <div className='banner-container'>
                                    <div
                                        dangerouslySetInnerHTML={{__html: el.text}}
                                        className={`banner-context ${color} ${position}`}
                                    />
                                    {scrollTo && (
                                        <ScrollToButton
                                            elementId={scrollTo.elementId}
                                            offset={offset}
                                            duration={1000}
                                        />
                                    )}
                                    {pressPage && (
                                        <ScrollLink
                                            smooth
                                            duration={1000}
                                            to='pressListAccreditation'
                                            offset={-100}
                                            className='scrollPressButton'
                                        >
                                            GET ACCREDITED
                                        </ScrollLink>
                                    )}
                                </div>
                            </div>
                        </>
                    ))
                    : data && (
                    <>
                        <div
                            style={{backgroundImage: `url(${data.url})`}}
                            className={`banner-img d-none d-md-block ${
                                fullHeight ? 'fullHeight' : ''
                            }`}
                        >
                            <div className='banner-container'>
                                <div
                                    dangerouslySetInnerHTML={{__html: data.text}}
                                    className={`banner-context ${color} ${position}`}
                                />
                                {scrollTo && (
                                    <ScrollToButton
                                        elementId={scrollTo.elementId}
                                        offset={offset}
                                        duration={1000}
                                    />
                                )}
                                {pressPage && (
                                    <ScrollLink
                                        smooth
                                        duration={1000}
                                        to='pressListAccreditation'
                                        offset={-100}
                                        className='scrollPressButton'
                                    >
                                        GET ACCREDITED
                                    </ScrollLink>
                                )}
                            </div>
                        </div>
                        <div
                            style={{
                                backgroundImage: `url(${
                                    data.mobile_url !== undefined && data.mobile_url !== null
                                        ? data.mobile_url
                                        : data.url
                                })`,
                            }}
                            className={`banner-img d-md-none d-block ${
                                fullHeight ? 'fullHeight' : ''
                            }`}
                        >
                            <div className='banner-container'>
                                <div
                                    dangerouslySetInnerHTML={{__html: data.text}}
                                    className={`banner-context ${color} ${position}`}
                                />
                                {scrollTo && (
                                    <ScrollToButton
                                        elementId={scrollTo.elementId}
                                        offset={offset}
                                        duration={1000}
                                    />
                                )}
                                {pressPage && (
                                    <ScrollLink
                                        smooth
                                        duration={1000}
                                        to='pressListAccreditation'
                                        offset={-100}
                                        className='scrollPressButton'
                                    >
                                        GET ACCREDITED
                                    </ScrollLink>
                                )}
                            </div>
                        </div>
                    </>
                )}
        </section>
    );
}
